import { Link } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";

const ADVANTAGES = [
  { ico:"package", t:"Un seul interlocuteur", d:"Plus besoin de coordonner plusieurs prestataires : une seule équipe suit votre projet de A à Z." },
  { ico:"zap",      t:"Mise en place plus rapide", d:"Les services étant pensés ensemble dès le départ, tout s'installe plus vite que pris séparément." },
  { ico:"shield",   t:"Cohérence de votre image", d:"Site, fiche Google et branding parlent le même langage visuel, du premier coup." },
  { ico:"barChart", t:"Un tarif optimisé", d:"Regroupés, nos services reviennent moins cher que si vous les commandiez un par un." },
  { ico:"users",    t:"Accompagnement structuré", d:"Un point de suivi régulier pendant plusieurs mois, pas juste une livraison puis plus rien." },
  { ico:"sparkle",  t:"Une solution qui évolue", d:"Vous pouvez toujours ajouter un service supplémentaire une fois les bases posées." },
];

const TIERS = [
  {
    key:"starter", featured:false, ico:"globe", name:"Pack Starter",
    tag:"Pour démarrer votre présence en ligne sans vous ruiner.",
    for:"Indépendants & petits commerces",
    feats:["Site vitrine 1 à 3 pages","Fiche Google Business optimisée","Logo & charte visuelle simple","1 mois de suivi après lancement"],
  },
  {
    key:"business", featured:true, ico:"package", name:"Pack Business Pro",
    tag:"L'offre la plus complète pour structurer et faire grandir votre activité.",
    for:"PME établies avec équipe",
    feats:["Site web professionnel complet","Fiche Google Business optimisée","Logiciel de gestion sur-mesure","Branding complet (logo, charte, supports)","Formation & suivi pendant 3 mois"],
  },
  {
    key:"premium", featured:false, ico:"cpu", name:"Pack Premium",
    tag:"Pour les structures multi-sites qui veulent tout centraliser.",
    for:"Multi-sites, franchises, groupes",
    feats:["Tout le contenu du Pack Business Pro","Automatisation des processus internes","Stratégie marketing digital incluse","Support prioritaire & suivi mensuel continu"],
  },
];

const MATCH = [
  { type:"Indépendant / artisan qui démarre", detail:"Vous avez besoin d'une présence en ligne simple et crédible, sans budget conséquent.", pack:"Pack Starter" },
  { type:"Commerce ou restaurant en activité", detail:"Vous voulez un site solide, une bonne visibilité Google et un outil de gestion adapté.", pack:"Pack Business Pro" },
  { type:"PME avec plusieurs employés", detail:"Vous cherchez à structurer vos outils internes tout en développant votre visibilité.", pack:"Pack Business Pro" },
  { type:"Entreprise multi-sites ou franchise", detail:"Vous avez besoin d'automatisation, de reporting et d'un accompagnement continu.", pack:"Pack Premium" },
  { type:"Association ou structure publique", detail:"Vous cherchez une présence claire et professionnelle sans complexité technique.", pack:"Pack Starter" },
];

export default function Packs() {
  useReveal();

  return (
    <div className="pagewrap">
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Nos offres tout-en-un</div>
            <h2 className="sh2">Les <em>Packs Layetech</em></h2>
            <p className="slead">Plutôt que de choisir vos services un par un, nos Packs réunissent ce dont votre entreprise a besoin dans une seule offre cohérente, pensée pour votre stade de développement.</p>
          </div>

          {/* AVANTAGES */}
          <div className="realgrid" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
            {ADVANTAGES.map((a, i) => (
              <div className="valc r" key={a.t} style={{ transitionDelay: `${i * .05}s` }}>
                <div className="valico"><Ico name={a.ico} size={19} color="#fff" /></div>
                <div className="valtxt"><strong>{a.t}</strong><span>{a.d}</span></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FORMULES */}
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Nos formules</div>
            <h2 className="sh2">Trois packs, <em>trois besoins</em></h2>
            <p className="slead">Chaque formule est un point de départ : elle peut toujours être ajustée à votre situation lors du premier échange.</p>
          </div>
          <div className="tiergrid">
            {TIERS.map((t, i) => (
              <div className={`tierc r ${t.featured ? "featured" : ""}`} key={t.key} style={{ transitionDelay: `${i * .08}s` }}>
                {t.featured && <div className="tierbadge">Le plus choisi</div>}
                <div className="tiericon"><Ico name={t.ico} size={24} /></div>
                <div className="tiername">{t.name}</div>
                <p className="tiertag">{t.tag}</p>
                <div className="tierfor"><Ico name="users" size={12} />{t.for}</div>
                <div className="tierfeats">
                  {t.feats.map(f => (
                    <div className="tierfeat" key={f}><Ico name="check" size={14} color="var(--blue-m)" />{f}</div>
                  ))}
                </div>
                <Link className="tierbtn" to={`/contact?sujet=pack-${t.key}`}>Demander un devis <Ico name="arrowR" size={14} /></Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* QUEL PACK POUR QUELLE ENTREPRISE */}
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Pas sûr·e de votre choix ?</div>
            <h2 className="sh2">Quel pack pour <em>quelle entreprise ?</em></h2>
            <p className="slead">Un repère pour vous orienter — le premier échange avec notre équipe permet ensuite d'affiner ensemble.</p>
          </div>
          <div className="matchgrid r" style={{ transitionDelay: ".1s" }}>
            {MATCH.map(m => (
              <div className="matchrow" key={m.type}>
                <div className="matchtype"><strong>{m.type}</strong><span>{m.detail}</span></div>
                <div className="matchpack">{m.pack}</div>
              </div>
            ))}
          </div>

          <div className="ctaband r" style={{ transitionDelay: ".2s" }}>
            <div>
              <h3>Toujours indécis·e ?</h3>
              <p>Parlez-nous simplement de votre activité : on vous recommande la formule la plus adaptée, sans pression.</p>
            </div>
            <Link className="ctabtn" to="/contact?sujet=projet">Discuter de mon projet <Ico name="arrowR" size={15} color="var(--blue)" /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}